const KEY = "ae_utm";

export function captureUtm() {
    try {
        if (sessionStorage.getItem(KEY)) return;
        const q = new URLSearchParams(window.location.search);
        sessionStorage.setItem(
            KEY,
            JSON.stringify({
                utm_source: q.get("utm_source") || "",
                utm_medium: q.get("utm_medium") || "",
                utm_campaign: q.get("utm_campaign") || "",
                utm_term: q.get("utm_term") || "",
                utm_content: q.get("utm_content") || "",
                landing_url: window.location.href,
            })
        );
    } catch (e) {
        /* storage unavailable */
    }
}

export function getUtm() {
    try {
        return JSON.parse(sessionStorage.getItem(KEY)) || {};
    } catch (e) {
        return {};
    }
}
